export const ApiEndpoints = {
  VENDOR_LIST: '/tms-onboarding/vendor/list',
  VENDOR_ONBOARD: '/tms-onboarding/vendor',
  VENDOR_DASHBOARD_COUNT: '/tms-onboarding/vendor/dashboard/count',
  VENDOR_DELETE: '/tms-onboarding/vendor',
  VENDOR_GET_BY_ID: '/tms-onboarding/vendor',
  VENDOR_UPDATE: '/tms-onboarding/vendor',
  VENDOR_CHANGE_STATUS: '/tms-onboarding/vendor/change-status',
  DRIVER_LIST: '/tms-onboarding/driver/list',
  DRIVER_DASHBOARD_COUNT: '/tms-onboarding/driver/dashboard/count',
  DRIVER_ONBOARD: '/tms-onboarding/driver',
  DRIVER_UPDATE: '/tms-onboarding/driver',
  DRIVER_DELETE: '/tms-onboarding/driver',
  DRIVER_GET_BY_ID: '/tms-onboarding/driver',
  DRIVER_CHANGE_STATUS: '/tms-onboarding/driver/change-status',
  VEHICLE_LIST: '/tms-onboarding/vehicle/list',
  VEHICLE_ONBOARD: '/tms-onboarding/vehicle',
  VEHICLE_DASHBOARD_COUNT: '/tms-onboarding/vehicle/dashboard/count',
  VEHICLE_DELETE: '/tms-onboarding/vehicle',
  VEHICLE_GET_BY_ID: '/tms-onboarding/vehicle',
  VEHICLE_UPDATE: '/tms-onboarding/vehicle',
  VEHICLE_CHANGE_STATUS: '/tms-onboarding/vehicle/change-status',
  VEHICLE_SPECIFICATIONS: '/tms-onboarding/vehicle-specifications',
  SINGLE_VEHICLE_SPECIFICATION: '/tms-onboarding/vehicle-specifications/',
  VEHICLE_MAKE_LIST: '/tms-onboarding/vehicle-make/list',
  VEHICLE_MODEL_LIST: '/tms-onboarding/vehicle-model/list',
  VEHICLE_TYPE_LIST: '/tms-onboarding/vehicle-type/list',
  ROUTES: '/routemaster/vehicle-routes',
  TRANSITS: '/routemaster/transits',
  HUB_ESTIMATE: '/routemaster/hubEstimate',
  CITY_RESTRICTIONS: '/tms-onboarding/city-wise-restrictions',
  CITY_RESTRICTIONS_LIST: '/tms-onboarding/city-wise-restrictions/list',
  CITY_RESTRICTIONS_BY_CITY: '/tms-onboarding/city-wise-restrictions',
  CITY_RESTRICTIONS_DASHBOARD:
    '/tms-onboarding/city-wise-restrictions/dashboard',
  STATES_AND_CITIES: '/routemaster/transits/city-state-zone',
  TRIP_LIST: '/tms-trip/trip/list',
  TRIP_CREATE: '/tms-trip/trip',
  TRIP_UPDATE: '/tms-trip/trip/update',
  TRIP_CHANGE_VEHICLE: '/tms-trip/trip/changeVehicle',
  TRIP_UPDATE_STATUS: '/tms-trip/trip/status',
  TRIP_DELETE: '/tms-trip/trip',
  TRIP_GET_BY_ID: '/tms-trip/trip',
  TRIP_CREATE_SCHEDULE_TRIP: '/tms-trip/schedule',
  TRIP_GET_SCHEDULE_TRIP: '/tms-trip/schedule',
  TRIP_UPDATE_SCHEDULE_TRIP: '/tms-trip/schedule',
  TRIP_DELETE_SCHEDULE_TRIP: '/tms-trip/schedule',
  DASHBOARD_STATS: '/tms-tracking/dashboard/stats',
  COMPLETED_TRIPS_ANALYTICS: '/tms-trip/dashboard/completed-trips-analytics',
  ONTIME_PERFORMANCE: '/tms-trip/dashboard/ontime-performance',
  AVERAGE_LOADED_CAPACITY: '/tms-trip/dashboard/average-loaded-capacity',
  TRIP_REPORTS: '/tms-trip/reports/trips',
  TRIP_REPORTS_DOWNLOAD: '/tms-trip/reports/trips/download',
  RATE_CARD: '/billing/rate-card',
  BILLING_GET_FILTER_SUGGESTIONS: '/billing/get-filter-suggestions',
  BILLING_GET_FILTERED_TRIPS: '/billing/get-filtered-trips',
};
